import React, { useEffect, useState } from 'react';
import Input from '../Input/Input';

function MessagesFilter({ type, form, isSelf }) {
  const [reset, setReset] = useState(false);
  useEffect(() => {
    if (reset) {
      setReset(false);
    }
  }, [reset]);

  return (
    <div className="flex flex-col w-full p-4 rounded-md border-1 border-[#C4C4C4] shadow-lg mb-4">
      <div className="mb-6">
        <p className="text-xl font-medium">Фильтр</p>
      </div>
      {type == 'employer_candidate' ? (
        <div className="mb-2">
          <Input type="search" name="filter.employer_inn" form={form} placeholder={'ИНН контрагента'} resetSearch={reset} />
        </div>
      ) : type == 'staff_staff' ? (
        <div className="mb-2">
          <Input type="search" name="filter.user_full_name" form={form} placeholder={'ФИО админа/менеджера'} resetSearch={reset} />
        </div>
      ) : type == 'staff_employer' ? (
        <>
          <div className="mb-2">
            <Input type="search" name="filter.employer_name" form={form} placeholder={'ФИО контрагента'} resetSearch={reset} />
          </div>{' '}
          <div className="mb-2">
            <Input type="search" name="filter.employer_inn" form={form} placeholder={'ИНН контрагента'} resetSearch={reset} />
          </div>
          {!isSelf && (
            <div className="mb-2">
              <Input type="search" name="filter.manager_full_name" form={form} placeholder={'ФИО менеджера'} resetSearch={reset} />
            </div>
          )}
        </>
      ) : type == 'staff_candidate' ? (
        <>
          <div className="mb-2">
            <Input type="search" name="filter.user_full_name" form={form} placeholder={'ФИО соискателя'} resetSearch={reset} />
          </div>{' '}
          {!isSelf && (
            <div className="mb-2">
              <Input type="search" name="filter.manager_full_name" form={form} placeholder={'ФИО менеджера'} resetSearch={reset} />
            </div>
          )}
        </>
      ) : type == 'support' ? (
        <div className="mb-2">
          <Input type="search" name="filter.employer_name" form={form} placeholder={'ФИО контрагента'} resetSearch={reset} />
        </div>
      ) : (
        <></>
      )}{' '}
      {type == 'staff_employer' && !isSelf && (
        <div className="relative flex gap-x-3 mt-1 -mb-1">
          <div className="flex h-6 items-center">
            <input
              id="onlyVacancy"
              type="checkbox"
              className="h-4 w-4 rounded border-gray-300 text-blue-500 focus:ring-blue-500 cursor-pointer"
              {...form?.register(`filter.has_vacancy`)}
              onChange={(e) => {
                form.setValue('filter.has_vacancy', e.target.checked);
                form.setValue('filterTouch', true);
              }}
            />
          </div>
          <div className="text-sm leading-6">
            <label htmlFor="onlyVacancy" className="font-medium text-gray-900 cursor-pointer">
              Только с вакансиями
            </label>
          </div>
        </div>
      )}
      <div className="mb-2  flex flex-col gap-y-2 mt-4">
        <button
          type="button"
          className="text-center border rounded py-2 px-4  text-button border-button border-1 w-full md:w-auto hover:text-white bg-white hover:bg-button transition ease-in-out duration-300"
          onClick={() => {
            setReset(true);
            form.setValue('filter', { has_vacancy: false });
            form.setValue('filterTouch', true);
          }}>
          Сбросить
        </button>
      </div>
    </div>
  );
}

export default MessagesFilter;
